const $ = require("jquery");
const facilityService = require("@modules/tools/facility-search/facilityService");
const ko = require("knockout");
const utility = require("@modules/tools/helpfulToolUtility");
var log = console.log;
define(function (require) {
    var ko = require("knockout");
    var $ = require("jquery");
    var dataLayerService = require("@modules/services/dataLayerService");
    var facilityService = require("@modules/tools/facility-search/facilityService");
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");
    var FacilityResultViewModel = require("@modules/tools/facilityResultViewModel");
    var urlParameters = require("@modules/tools/urlParameters");
    var geocoder = require("@modules/tools/geocoder");
    var querystring = require("querystring");
    var utility = require("@modules/tools/helpfulToolUtility");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var whitelistUrlService = require("@modules/tools/whitelistUrlService");
    // HospitalSearchViewModel ctor
    return function (gtmDataLayerPush, gmapApi) {
        var self = this;
        var focusedElement;
        var defaultParameters = {
            zipOrAddress: "",
            radius: "5",
            pageNumber: 1,
            year: window.scan.aepYears[window.scan.aepYears.length - 1],
            sort: "distance",
            deepLink: false
        };

        var initialLoad = true;

        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var pageSize = window.scan.resultPageSize > 0 ? window.scan.resultPageSize : 20;

        dataLayer.push({
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Facility Search"
        });

        var tempResults = [];

        var urlParams = urlParameters.read();
        var returnUrl = getPropertyCaseInsensitive(urlParams, "return_url");

        self.isDrx = ko.observable(false);
        self.selectPcp = ko.observable(false);

        if (returnUrl) {
            whitelistUrlService
                .validateUrl(returnUrl)
                .done(function (data) {
                    self.isDrx(true);
                })
                .fail(function (jqXHR) {
                    console.log(jqXHR.responseJSON.Message);
                });
        }

        var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));

        if (urlParams.year) {
            urlParams.year = parseInt(urlParams.year, 10); // make the year a number if set in url
        }
        if (urlParams.pageNumber) {
            urlParams.pageNumber = parseInt(urlParams.pageNumber, 10); // make the year a number if set in url
        }

        if (urlParams.deepLink && (urlParams.deepLink === "true" || urlParams.deepLink === "false")) {
            urlParams.deepLink = JSON.parse(urlParams.deepLink);
        } else {
            urlParams.deepLink = false;
        }

        if (urlParams.groups && !$.isArray(urlParams.groups)) {
            urlParams.groups = [urlParams.groups];
        }

        if (urlParams.plans && !$.isArray(urlParams.plans)) {
            urlParams.plans = [urlParams.plans];
        }

        //Deep link
        self.deepLink = ko.observable(urlParams.deepLink || false);
        self.loadDefaultFacilityType = ko.observable(true);
        self.loadDefaultZipOrAddress = ko.observable(true);
        self.loadDefaultState = ko.observable(true);
        self.loadDefaultFacilityName = ko.observable(true);
        self.loadDefaultRadius = ko.observable(true);

        if (urlParams.facilityType && self.deepLink()) {
            self.loadDefaultFacilityType(false);
        }

        if (urlParams.zipOrAddress && self.deepLink()) {
            self.loadDefaultZipOrAddress(false);
        }

        if (urlParams.name && self.deepLink()) {
            self.loadDefaultFacilityName(false);
        }

        if (urlParams.radius && self.deepLink()) {
            self.loadDefaultRadius(false);
        }

        if (self.deepLink()) {
            self.loadDefaultState(false);
        }

        self.currentSearchParameters = ko.observable();

        // various flags/state properties
        // self.isSearching = ko.observable(true);  // duplicate
        self.isSearchStarted = ko.observable(false);
        self.pageSize = ko.observable(pageSize);
        self.pageNumber = ko.observable(urlParams.pageNumber || 1);
        self.fatalError = ko.observable(false);
        self.noResultFound = ko.observable(false);
        self.detailId = ko.observable();
        self.isLeavingForDetailPage = ko.observable(false);
        self.hasSearchRun = ko.observable(false);
        var isSystemResettingFilters = false;
        self.fromQueryString = ko.observable(true);
        // The following is for the updated data label text that appears when printing the results
        // list as both hospital and facility share the FaciltyResult view.

        // form field values
        self.year = ko.observable().extend({ defaultOnNull: defaultParameters.year });
        self.zipOrAddress = ko.observable().extend({ defaultOnNull: defaultParameters.zipOrAddress });
        self.name = ko.observable(urlParams.name || "");
        self.radius = ko.observable();
        self.sort = ko.observable().extend({ defaultOnNull: defaultParameters.sort });
        self.state = ko.observable(urlParams.state || window.scan.stateValueDefault || "CA");
        self.facilityType = ko.observable(urlParams.facilityType || "");

        self.groups = ko.observableArray([]);
        self.plans = ko.observableArray([]);

        if (urlParams.scan_state) {
            self.state(urlParams.scan_state);
            urlParams.state = urlParams.scan_state;
        }

        self.isViewAllFilterCollapsed = ko.observable(false);

        self.allFilterCallapsed = function (ele) {
            self.isViewAllFilterCollapsed(ele);
        };

        self.facilityTypeIsSet = ko.computed(function () {
            return self.facilityType() !== "";
        });

        var primaryFilters = {
            sort: self.sort,
            zipOrAddress: self.zipOrAddress,
            radius: self.radius,
            name: self.name,
            year: self.year,
            facilityType: self.facilityType
        };

        var secondaryFilters = {
            groups: self.groups,
            plans: self.plans,
            productTypes: self.plans
        };

        if (self.state() && self.year()) {
            getfaciliytypes(self.state());
        }

        self.facilityType.subscribe(function () {
            if (self.facilityType() !== "") {
                gtmDataLayer();
            } else {
                self.name("");
            }
        });

        self.setFacilityType = function (value) {
            self.facilityType(value);
            $("#facilityTypeSelector").collapse("toggle");
        };

        self.name.subscribe(function () {
            if (self.name() !== "") {
                gtmDataLayer();
            }
        });

        function gtmDataLayer() {
            var dataLayerEvent = {
                state_selected: "medical_facility_finder",
                your_address: self.state(),
                radius_selected: self.radius(),
                facility_type: self.facilityType(),
                facility_name: self.name()
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
        }
        // these are the options available from the select lists.
        self.yearOptions = ko.observableArray(window.scan.aepYears);
        self.radiusOptions = ko.observableArray(utility.mapFacets(window.scan.emptyRadiusOptions));
        self.nameOptions = ko.observableArray([]);
        // self.stateOptions = ko.observableArray(utility.mapFacets(window.scan.stateOptions));
        self.stateOptions = ko.observableArray(window.scan.facilityStates || []);
        self.facilityTypeOptions = ko.observableArray(window.scan.facilityTypes || []);
        self.groupOptions = ko.observableArray([]);
        self.planOptions = ko.observableArray([]);

        // ************************************************************************
        // Overlay ****************************************************************
        // Group Popup text filter
        self.groupNameFilter = ko.observable("");
        self.groupsTempNew = ko.observableArray([]);
        self.groupsTempOptions = ko.observableArray([]);
        self.groups.subscribe(function () {
            self.groupsTempNew(JSON.parse(JSON.stringify(self.groups())));
        });
        self.groupOptions.subscribe(function () {
            self.groupsTempOptions(self.groupOptions()); //.sort(utility.sortByText)
        });
        self.groupsTempOptionsFiltered = ko.computed(function () {
            return this.groupsTempOptions().filter(function (group) {
                if (!self.groupNameFilter() || group.name.toLowerCase().indexOf(self.groupNameFilter().toLowerCase()) !== -1) return group;
            });
        }, this);
        self.clearGroups = function () {
            self.groupsTempNew([]);
        };
        self.groupsTempNewClear = function () {
            self.groupsTempNew(JSON.parse(JSON.stringify(self.groups())));
            self.groupNameFilter("");
        };
        self.groupsMakeTempReal = function (data, event) {
            self.groups(JSON.parse(JSON.stringify(self.groupsTempNew())));
            self.groupNameFilter("");
        };

        // ************************************************************************
        // Overlay ****************************************************************
        // Plans Popup text filter
        self.planNameFilter = ko.observable("");
        self.plansTempNew = ko.observableArray([]);
        self.plansTempOptions = ko.observableArray([]);
        self.plans.subscribe(function () {
            self.plansTempNew(JSON.parse(JSON.stringify(self.plans())));
        });
        self.planOptions.subscribe(function () {
            self.plansTempOptions(self.planOptions()); //.sort(utility.sortByText)
        });
        self.plansTempOptionsFiltered = ko.computed(function () {
            return this.plansTempOptions().filter(function (plan) {
                if (!self.planNameFilter() || plan.name.toLowerCase().indexOf(self.planNameFilter().toLowerCase()) !== -1) return plan;
            });
        }, this);
        self.clearPlans = function () {
            self.plansTempNew([]);
        };
        self.plansTempNewClear = function () {
            self.plansTempNew(JSON.parse(JSON.stringify(self.plans())));
            self.planNameFilter("");
        };
        self.plansMakeTempReal = function (data, event) {
            self.plans(JSON.parse(JSON.stringify(self.plansTempNew())));
            self.planNameFilter("");
        };

        self.state.subscribe(function (value) {
            getfaciliytypes(value);
        });
        self.facilityNameDefault = ko.observable(window.scan.defaultFacilityNameLabel || "");
        self.facilityTypeOrDefault = ko.computed(function () {
            const facilty = self.facilityTypeOptions().find(item => {
                return item.Value === self.facilityType();
            });
            return facilty ? facilty.Name : window.scan.defaultFacilityNameLabel || "";
        });

        self.facilityTypeIsDefault = ko.computed(function () {
            return self.facilityTypeOrDefault() === window.scan.defaultFacilityNameLabel;
        });

        // loading status
        self.loadingResults = ko.observable(false);
        self.displayRequiredFieldError = ko.observable(false);

        //we need this to populate the updated date in the footer for the PDF
        self.contextItemId = ko.observable(window.scan.contextItemId);
        self.totalResults = ko.observable(0);
        self.dataLastUpdated = ko.observable("");
        self.results = ko.observableArray();
        self.pageList = ko.observableArray([]);

        self.zipOrAddress.subscribe(function (value) {
            if (!value) {
                self.radiusOptions(utility.mapFacets(window.scan.emptyRadiusOptions));
                self.isSearchStarted(false);
            }
        });
        // for typeahead
        self.suggestions = ko.observableArray([]);

        var usedNonDefaultParams = utility.initializeFilters(self, urlParams, defaultParameters);

        // This needs to sit above the self.filters and self.filters.subscribe definitions
        // so that it can fire first. See note in FB38870.
        self.zipOrAddress.subscribe(function () {
            // This flag keeps loadFacets from running.
            var isZipChangingRadius = true;

            if (self.zipOrAddress()) {
                self.radius(5);
            } else {
                self.radius(null);
            }

            isZipChangingRadius = false;
        });

        // this is a computed that will change whenever the user actually changes any of the filters that appear on the page.
        self.filters = ko.computed(function () {
            focusedElement = document.activeElement;
            if (!self.year()) {
                self.isSearchStarted(false);
                utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            }

            if (!utility.filtersHaveNonDefaultValues(primaryFilters, defaultParameters)) {
                self.isSearchStarted(false);
                utility.resetFiltersToDefaults(secondaryFilters, defaultParameters);
            }

            return {
                year: self.year(),
                zipOrAddress: self.zipOrAddress(),
                name: self.name(),
                radius: self.radius(),
                sort: self.sort(),
                groups: self.groups(),
                plans: self.plans(),
                productTypes: self.plans(),
                facilityType: self.facilityType()
            };
        });

        self.filters.subscribe(function () {
            if (isSystemResettingFilters) {
                return false;
            }
            self.pageNumber(1);
            self.results([]);
            self.totalResults(0);
            self.dataLastUpdated("");
            self.displayRequiredFieldError(false);
            self.fatalError(false);
            self.currentSearchParameters(null);
            tempResults = [];
        });

        self.urlParameters = ko.computed(function () {
            var filters = self.filters();

            return {
                year: filters.year,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                sort: filters.sort,
                facilityType: filters.facilityType,
                pageNumber: self.pageNumber(),
                detailId: self.detailId(),
                path: path,
                deepLink: self.deepLink(),
                state: self.state(),
                groups: filters.groups,
                plans: filters.plans,
                productTypes: filters.plans
            };
        });

        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, defaultParameters);
        });

        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                year: filters.year,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                facilityType: filters.facilityType,
                radius: filters.radius,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize(),
                sort: self.sort(),
                state: self.state(),
                groups: filters.groups,
                plans: filters.plans,
                productTypes: filters.plans
            };
        });

        self.hasMore = ko.computed(function () {
            if (!self.totalResults()) {
                return false;
            }
            if (self.pageSize() * self.pageNumber() >= self.totalResults()) {
                return false;
            }
            return true;
        });

        // this id will be used to keep track of the latest search that we performed.
        // we will throw out any search results that were not for the latest ID.
        // this helps address the scenario where the user is rapidly changing filters
        // and triggering multiple searches.
        // we only want to display results for the last set of search parameters.
        var lastSearchRequestId = 1;

        var executeSearch = function () {
            if (!self.areAllRequiredFieldsPopulated()) {
                self.isSearchStarted(false);
                return;
            }

            var id = ++lastSearchRequestId;

            self.loadingResults(true);
            self.fatalError(false);

            var parameters = self.searchParameters();

            gtmDataLayerPush(parameters, defaultParameters);

            facilityService
                .getResults(parameters)
                .done(function (results) {
                    // debugger;

                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    console.log(">>>>>>>>>> executeSearch returned " + results.CurrentResults.length + " results @ " + new Date());

                    self.results([]); // clear out results from previous page
                    tempResults = tempResults.concat(results.CurrentResults);

                    for (var i in results.CurrentResults) {
                        if (results.CurrentResults.hasOwnProperty(i)) {
                            self.results.push(new FacilityResultViewModel(self, results.CurrentResults[i], results.latitude, results.longitude, parameters.year, parameters.radius));
                        }
                    }
                    if (self.results().length == 0) {
                        self.noResultFound(true);
                    }

                    self.currentSearchParameters(parameters);
                    self.radiusOptions(results.Facets.Radius);

                    if (results.Facets["GROUP"]) {
                        self.groupOptions(results.Facets["GROUP"].sort(utility.sortByText));
                    }
                    if (results.Facets["PRODUCT"]) {
                        self.planOptions(results.Facets["PRODUCT"].sort(utility.sortByText));
                    }

                    self.totalResults(results.TotalResults);
                    self.dataLastUpdated(results.LastUpdate);
                    self.loadingResults(false);
                    self.isSearchStarted(false);

                    utility.recalculatePageNumbers(self);
                    self.hasSearchRun(true);

                    if ($(focusedElement).attr("name")) {
                        setTimeout(function () {
                            $("#" + $(focusedElement).attr("id")).focus();
                        }, 100);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }
                    self.fatalError(true);
                    self.loadingResults(false);
                });
        };

        function getfaciliytypes(state, fromQueryString) {
            const parameters = {
                state: state,
                year: self.year()
            };
            facilityService.getFacilityTypes(parameters).done(function (results) {
                try {
                    if (results && results.length > 0) {
                        self.facilityTypeOptions(results);
                        if (self.fromQueryString()) {
                            self.facilityType(urlParams.facilityType);
                        }
                    } else {
                        self.facilityTypeOptions([]);
                    }
                } catch (e) {
                    log(e.message);
                    self.isSearchStarted(false);
                }
            });
        }

        self.searchParameters.subscribe(function (newValue) {
            if (!self.areAllRequiredFieldsPopulated()) {
                return false;
            }
            if (isSystemResettingFilters) {
                return false;
            }
            tempResults = [];
            // set isSearchStarted to show spinner
            self.isSearchStarted(true);
            executeSearch();
        });

        // status indicators
        self.pages = ko.computed(function () {
            return Math.ceil(self.totalResults() / self.pageSize());
        });
        self.isAEP = ko.computed(function () {
            return self.yearOptions() && self.yearOptions().length > 1;
        });

        self.isAnyRequiredFieldPopulated = function () {
            return (self.zipOrAddress() && self.zipOrAddress().length >= 5) || (self.name() && self.name().length >= 3);
        };

        self.areAllRequiredFieldsPopulated = function () {
            return (self.zipOrAddress() && self.zipOrAddress().length >= 5) || (self.name() && self.name().length >= 3);
        };

        self.arePrimaryFiltersEnabled = ko.computed(function () {
            return !self.isAEP() || self.year();
        });

        self.areSecondaryFiltersEnabled = ko.computed(function () {
            return (!self.isAEP() || self.year()) && self.isAnyRequiredFieldPopulated();
        });

        // clear filter functions

        self.clearAll = function () {
            location.href = location.href.split("?")[0];
        };

        self.clearYear = function () {
            self.year(null);
        };

        self.clearName = function () {
            self.name(null);
        };
        self.clearLocation = function () {
            self.zipOrAddress(null);
            self.radius(null);
        };

        var clearFacetOptions = function () {
            self.nameOptions([]);
            self.facilityTypeOptions([]);
            self.groupOptions([]);
            self.planOptions([]);
        };

        self.resetFilters = function () {
            isSystemResettingFilters = true;

            self.hasSearchRun(false);

            tempResults = [];
            self.results([]);
            self.totalResults(0);
            self.dataLastUpdated("");

            utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            clearFacetOptions();

            self.clearYear();
            isSystemResettingFilters = false;
            getfaciliytypes(self.state(), self.fromQueryString(false));
            self.noResultFound(false);
            self.facilityType("");

            // self.plans(urlParams.plans);

            self.deepLink(false);
            self.loadDefaultFacilityType(true);
            self.loadDefaultZipOrAddress(true);
            self.loadDefaultState(true);
            self.loadDefaultFacilityName(true);
            self.loadDefaultRadius(true);
        };

        self.beginSearch = function () {
            self.fatalError(false);
            if (self.isAnyRequiredFieldPopulated()) {
                self.isSearchStarted(true);
                self.results([]);
                self.totalResults(0);
                self.dataLastUpdated("");
                executeSearch(true);
            } else {
                self.displayRequiredFieldError(true);
            }
        };

        self.setFocusOnResults = function () {
            utility.setFocusOnResults();
        };
        self.loadPrev = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) - 1);
            utility.setFocusOnResults();
        };
        self.loadNext = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) + 1);
            utility.setFocusOnResults();
        };
        self.setPage = function (pageObject) {
            utility.setPageNumber(self, pageObject);
        };
        self.setLastPage = function () {
            self.pageNumber(parseInt(self.pages(), 10));
            utility.setFocusOnResults();
        };

        self.viewDetails = function (providerId, institutionId, addressId, lat, lng, facilityType) {
            self.isLeavingForDetailPage(true);
            self.detailId(providerId);

            var query = {
                // required
                providerId: providerId,
                institutionId: institutionId,
                addressId: addressId,
                latitude: lat,
                longitude: lng,
                radius: self.radius(),
                year: self.year(),
                zipOrAddress: self.zipOrAddress(),
                facilityType: facilityType,

                // for future use
                name: self.name(),
                Return_URL: returnUrl,

                // pass through URL params
                path: path,
                groups: self.groups(),
                plans: self.plans(),
                productTypes: self.plans()
            };

            query = urlParameters.reduceParams(query, {});
            var urlName = "";
            var item = self.results().filter(x => x.providerId() == providerId);
            if (item != null && item != undefined) {
                urlName = item[0].name();
            }
            var dataLayerEvent = {
                event: "medical_facility_finder",
                medical_facility_results: urlName
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
            window.location.href = window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        };

        self.pdfUrl = ko.computed(function () {
            var params = self.currentSearchParameters();

            if (!params) {
                return null;
            }

            var filteredParams = urlParameters.reduceParams(params, defaultParameters, false);

            if (self.isAEP()) {
                filteredParams.year = self.year();
            }

            filteredParams.contextItemId = self.contextItemId();
            filteredParams.radius = self.radius();
            filteredParams.pageNumber = self.pageNumber();
            filteredParams.pageSize = self.pageSize();

            return "/controller/FacilitySearchPdf/Download?" + querystring.stringify(filteredParams);
        });

        self.emailUrl = ko.computed(function () {
            var urlParts = window.location.href.split("/");

            var domain = urlParts[0] + "//" + urlParts[2],
                downloadLink = domain + self.pdfUrl(),
                subject = encodeURIComponent("Your SCAN Search"),
                body = encodeURIComponent("Download your PDF here: " + downloadLink),
                emailUrl = "mailto:?subject=" + subject + "&body=" + body;

            return emailUrl;
        });

        self.triggerGeolocation = function () {
            geoLocateZipcode();
        };

        function geoLocateZipcode() {
            // use current location to get results
            try {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var latitude = position.coords.latitude;
                            var longitude = position.coords.longitude;

                            // chrome dev tools allows you to set geo sensor to 33.8071979, -118.1444659 (SCAN HQ)
                            geocoder.geodecode(latitude, longitude).then(function (result) {
                                self.zipOrAddress(result.zipcode); // this kicks off a filter update
                            });
                        },
                        function () {
                            console.log("user declined geolocation");
                        }
                    );
                }
            } catch (e) {
                console.log(e.message);
            }
        }

        if (!self.zipOrAddress()) {
            geoLocateZipcode();
        } else {
            // retrieve the full set of results
            var maxPage = self.pageNumber();
            var initialPageSize = pageSize;

            if (maxPage > 1) {
                self.pageSize(maxPage * initialPageSize);
            }

            console.log("page load searching");
            self.beginSearch();
            self.pageSize(initialPageSize);
            self.pageNumber(maxPage);
        }
        initialLoad = false;

        if (gmapApi.load()) {
            setTimeout(function () {
                // Google API Autocomplete for addresses
                var defaultBounds = new window.google.maps.LatLngBounds(new google.maps.LatLng(36.77825900000001, -124.6474231875), new window.google.maps.LatLng(36.77825900000001, -114.1884388125));

                var options = {
                    bounds: defaultBounds
                };

                var input = $(".google-address-lookup").get(0); //document.getElementById("lookup-address");
                var autocomplete;

                autocomplete = new google.maps.places.Autocomplete(input, options);

                google.maps.event.addListener(autocomplete, "place_changed", function () {
                    // console.log("auto complete address selected");
                    var place = this.getPlace();
                    self.zipOrAddress(place.formatted_address);
                });
            }, 1000);
        }
    };
});
